export const REPORT_DURATION_FORMAT = 'h[h] mm[m]';
export const NO_DATA_FILTERS_MESSAGE = 'Try a different time range or set of filters';
export const NO_DATA_COLUMNS_MESSAGE = 'Turn on at least one column to see data';
export const NO_DATA_TAG_FILTER_MESSAGE =
  "This widget only works when the tag filter is set to match 'Any tag'";
